import { render, staticRenderFns } from "./BoardComponent.vue?vue&type=template&id=3f02ec81&"
import script from "./BoardComponent.vue?vue&type=script&lang=js&"
export * from "./BoardComponent.vue?vue&type=script&lang=js&"
import style0 from "./BoardComponent.vue?vue&type=style&index=0&id=3f02ec81&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports